import { globalTheme, Mixin } from '@clds/component-theme';
import { TypographySize } from '@clds/typography';

interface ThemeOptions {
  fontSize?: TypographySize;
  lineHeight?: TypographySize;
}

interface ThemeConfiguration {
  fontSize?: Mixin<string>;
  lineHeight?: Mixin<string>;
}

export const getThemeConfiguration = (options: ThemeOptions): ThemeConfiguration => {
  const themeOverrides: ThemeConfiguration = {};
  if (options.fontSize) {
    themeOverrides.fontSize = globalTheme.font.size[options.fontSize];
  }
  if (options.lineHeight) {
    themeOverrides.lineHeight = globalTheme.font.size[options.lineHeight];
  }
  return themeOverrides;
};
